/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import HealthEntryService from '../../../../apiServices/HealthEntryService';
import HelpView from '../../healthEntry/components/HelpView';
import PreformattedText from '../../../components/PreformattedText';
import COLORS from '../../../styles/Colors';

interface Props {
  searchResult: any;
  onLongDefinitionLoaded?(): void;
}

const MedliLongDefinitionView: React.FC<Props> = (props) => {
  const { searchResult, onLongDefinitionLoaded } = props;

  const [longDefinition, setLongDefinition] = React.useState('');
  const url = searchResult && searchResult.definitionURL();

  const loadLongDefinition = () => {
    HealthEntryService.definition(url, (apiError, htmlData) => {
      setLongDefinition(htmlData.replace(/<a /g, '<a target="_blank" '));
      if (onLongDefinitionLoaded) {
        onLongDefinitionLoaded();
      }
    });
  };

  React.useEffect(() => {
    if (url) {
      loadLongDefinition();
    }
  }, [url]);

  return (
    <HelpView
      title={searchResult.name()}
      htmlContent={<PreformattedText textClassName="font-body"><div dangerouslySetInnerHTML={{ __html: longDefinition }} /></PreformattedText>}
      footerContent={<FormattedMessage id="medicalTermDef.source.field.label" values={{ string1: searchResult.longDefinitionSource() }} />}
      linkColor={COLORS.brandDarkAccent}
    />
  );
};

export default MedliLongDefinitionView;
